import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Recipe } from '../models/recipe.model';

import { environment } from '../../environments/environment';

const API_URL = environment.apiUrl;

@Injectable({ providedIn: 'root' })
export class RecipeService {
  constructor(private http: HttpClient) {}

  getRecipes(): Observable<Recipe[]> {
    return this.http.get<Recipe[]>(`${API_URL}/api/bakery/recipes`).pipe(
      map(recipes => recipes.map(r => this.normalize(r)))
    );
  }

  getRecipeById(id: string): Observable<Recipe | undefined> {
    return this.http.get<Recipe>(`${API_URL}/api/bakery/recipes/${id}`).pipe(
      map(r => this.normalize(r))
    );
  }

  // ── Admin methods ──
  getAllRecipesAdmin(headers: HttpHeaders): Observable<Recipe[]> {
    return this.http.get<Recipe[]>(`${API_URL}/api/bakery/recipes/all`, { headers }).pipe(
      map(recipes => recipes.map(r => this.normalize(r)))
    );
  }

  createRecipe(recipe: Partial<Recipe>, headers: HttpHeaders): Observable<Recipe> {
    return this.http.post<Recipe>(`${API_URL}/api/bakery/recipes`, recipe, { headers });
  }

  updateRecipe(id: string, recipe: Partial<Recipe>, headers: HttpHeaders): Observable<Recipe> {
    return this.http.put<Recipe>(`${API_URL}/api/bakery/recipes/${id}`, recipe, { headers });
  }

  deleteRecipe(id: string, headers: HttpHeaders): Observable<any> {
    return this.http.delete(`${API_URL}/api/bakery/recipes/${id}`, { headers });
  }

  private normalize(r: any): Recipe {
    const raw = { ...r, id: String(r.id) };
    if (typeof raw.ingredients === 'string') {
      try { raw.ingredients = JSON.parse(raw.ingredients); } catch { raw.ingredients = []; }
    }
    if (typeof raw.instructions === 'string') {
      try { raw.instructions = JSON.parse(raw.instructions); } catch { raw.instructions = []; }
    }
    if (typeof raw.tags === 'string') {
      try { raw.tags = JSON.parse(raw.tags); } catch { raw.tags = []; }
    }
    if (!Array.isArray(raw.ingredients)) raw.ingredients = [];
    if (!Array.isArray(raw.instructions)) raw.instructions = [];
    if (!Array.isArray(raw.tags)) raw.tags = [];
    return raw;
  }
}
